import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }

import { authService } from "@/auth/authSingleton";
import log from "loglevel";
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthenticationRequired',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const popupOpen = ref(false);

onMounted(async () => {
    await triggerAuth()
});

async function triggerAuth () {
    if (popupOpen.value) return;
    try {
        popupOpen.value = true; 
        await authService.authenticate();
        const redirectPath = route.query.redirect || "/";
        router.replace(redirectPath as string);
    } catch (error) {
        log.error("Authentication failed:", error);
    } finally {
        popupOpen.value = false;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode("Your session has expired. To authenticate your account please follow the instructions in a  "),
    _createElementVNode("a", {
      href: "#",
      onClick: triggerAuth,
      style: {"text-decoration":"none"}
    }, "pop-up"),
    _createTextVNode(". ")
  ]))
}
}

})